export const iconFontAwesomeFilmVideoMicrophoneLinesSlash = (
	<i className="fa-solid fa-microphone-lines-slash"></i>
);
